import type { FC } from 'react';

import { cn } from '@yanolja-rnd/nol-design-system';

interface PriceSectionProps {
  price: {
    text: string;
    isValid: boolean;
  };
  priceUnit: string | null;
  discountRate?: string;
  isLegacyPcSize?: boolean;
}

export const PriceSection: FC<PriceSectionProps> = ({ price, priceUnit, discountRate, isLegacyPcSize = false }) => (
  <div className="flex flex-row-reverse flex-wrap items-center justify-end h-[1.6rem] mt-4 overflow-hidden pc:h-[2.4rem]">
    {price.isValid ? (
      <>
        <div className="flex items-center flex-shrink-0">
          <span
            className={cn('typography-body-13-bold pc:typography-subtitle-20-bold', {
              'pc:typography-subtitle-18-bold': isLegacyPcSize,
            })}
          >
            {price.text}
          </span>
          {!!priceUnit && (
            <span
              className={cn('typography-caption-11-bold pc:typography-subtitle-18-bold', {
                'pc:typography-subtitle-16-bold': isLegacyPcSize,
              })}
            >
              {priceUnit}
            </span>
          )}
        </div>
        {!!discountRate && (
          <span
            className={cn('mr-4 typography-body-13-regular text-text-accent-medium pc:typography-subtitle-20-regular', {
              'pc:typography-subtitle-18-regular': isLegacyPcSize,
            })}
          >
            {discountRate}
          </span>
        )}
      </>
    ) : (
      <span className="typography-caption-11-bold pc:typography-subtitle-18-bold text-text-neutral-sub whitespace-nowrap">
        {price.text}
      </span>
    )}
  </div>
);
